import {useState, useEffect, useCallback} from "react";
import { loadConnectAndInitialize } from "@stripe/connect-js";

let loading = false;

export const useStripeConnect = (connectedAccountId) => {
  const [stripeConnectInstance, setStripeConnectInstance] = useState(null);
  const [isOnboarded, setIsOnboarded] = useState(false);
  const [stripeLoaded, setStripeLoaded] = useState(false);

  const fetchClientSecret = useCallback(async (connectId = null) => {
    if(!connectedAccountId && !connectId) {
      setStripeLoaded(true);
      return;
    }

    const id = connectId ?? connectedAccountId;

    const response = await fetch("/api/stripe/account_session", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        account: id,
      }),
    });

    if (!response.ok) {
      // Handle errors on the client side here
      const { error } = await response.json();
      throw error;
    } else {
      const { client_secret: clientSecret, is_onboarded, requires_update} = await response.json();
      setIsOnboarded(is_onboarded);
      setStripeLoaded(true);
      if(requires_update) {
        await fetch("/api/stripe/update_account", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            account: id,
          }),
        });
      }
      loading = false
      return clientSecret;
    }
  }, [connectedAccountId]);

  const getStatus = async (connectId = null) => {
    setStripeLoaded(false);
    await fetchClientSecret(connectId);
  }

  useEffect(() => {
    if(loading) {
      return;
    }

    loading = true;
    if (connectedAccountId && !stripeLoaded) {
      setStripeConnectInstance(
        loadConnectAndInitialize({
          publishableKey: process.env.NEXT_PUBLIC_STRIPE_KEY,
          fetchClientSecret: fetchClientSecret,
          appearance: {
            overlays: "dialog",
            variables: {
              colorPrimary: "#587500",
              fontFamily: 'sans-serif',
            },
          },
        })
      );
    } else {
      setStripeLoaded(true);
      loading = false
    }
  }, [connectedAccountId, fetchClientSecret, stripeLoaded]);

  return [stripeConnectInstance, isOnboarded, stripeLoaded, getStatus];
};

export default useStripeConnect;
